export default __webpack_public_path__ + "static/media/grid_view.38f475a1.svg";